'use client'; // Ensure this is a client component

import { createI18n } from '@/i18n/i18n';
import { cookieName } from '@/i18n/settings';
import { ReactNode, useEffect, useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';

// Resources are bundled and initialised synchronously, so children render on
// the first pass (server included) — no blank screen while i18n "loads".
function I18nProviderWrapper({
  children,
  lng
}: {
  children: ReactNode;
  lng: string;
}) {
  const i18n = useMemo(() => createI18n(lng), [lng]);

  // Remember the language the visitor is actually reading, so a link without
  // a locale (/, /login, an auth redirect) brings them back to it instead of
  // the browser's language. Set here, not in the proxy: the proxy also sees
  // prefetches of the other language's links.
  useEffect(() => {
    document.cookie = `${cookieName}=${lng}; path=/; max-age=31536000; samesite=lax`;
  }, [lng]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

export default I18nProviderWrapper;
